import { render, staticRenderFns } from "./CarrierEdit.vue?vue&type=template&id=24b35e1e&scoped=true"
import script from "./CarrierEdit.vue?vue&type=script&lang=js"
export * from "./CarrierEdit.vue?vue&type=script&lang=js"
import style0 from "./CarrierEdit.vue?vue&type=style&index=0&id=24b35e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b35e1e",
  null
  
)

export default component.exports